<template>
  <section class="ctn">
    <header class="header">
      <div class="flex-container">
        <div>
          <router-link v-if="projectId && projectPrice.length" class="paper-action" :to="{ path: `/monitorings/${projectId}/edit` }"><heim-icon icon="add"></heim-icon><span>{{ $t('edit') }} {{ $t('contract') }}</span></router-link>
        </div>
        <router-link class="paper-action" to="/monitorings/new"><heim-icon icon="add"></heim-icon><span>{{ $t('info') }} {{ $t('contract') }}</span></router-link>
      </div>
    </header>
    <section class="table">
      <div class="flex-container">
        <heim-select
          label="Choisir un projet"
          :data="projects"
          label-key="name"
          value-key="id"
          v-model="selectedProjectId"
          @input="handleSelectProject"
        >
        </heim-select>
         <heim-button v-if="employeePwd" type="submit" @click.native="handleSave">Photographier projets</heim-button>
        <form v-if="!employeePwd && selectedProjectId" @submit.prevent="openModal">
          <heim-button type="submit">Afficher les coûts</heim-button>
        </form>
      </div>
    </section>
    <section class="table" v-if="selectedProjectId">
      <heim-table :data="computedProjectTime" :columns="['label', 'days', 'price']" cols="3">
        <template slot="thead" slot-scope="props">
          <th class="only-mobile"></th>
          <th class="main">{{ $t('projectMonitoring') }}</th>
          <th>{{ $t('numberDay') }}</th>
          <th v-if="employeePwd">{{ $t('cost') }}</th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr :key="'sites-'+index">
            <td class="only-mobile">
              <heim-icon-button
                :class="show(item)?'opened':''"
                class="icon-button"
                @click.native="openDetail(item)">
                <heim-icon icon="chevron-right"></heim-icon>
              </heim-icon-button>
            </td>
            <td>{{ $t(item.label) }}</td>
            <td class="">{{ item.days | number }}</td>
            <td v-if="employeePwd" class="">{{ item.price | currency }}</td>
          </tr>
          <transition name="slide-fade" :key="'detail-'+index">
            <tr v-if="show(item)" class="detail only-mobile" :data-detail="item.id">
              <td class="detail-row" :colspan="cols">
                <div class="detail-container">
                  <div class="row">
                    <div class="item">
                      <span class="label">{{ $t('projectMonitoring') }}</span>
                      <div>{{ $t(item.label) }}</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('numberDay') }}</span>
                      <div>{{ item.days | number }}</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('cost') }}</span>
                      <div>{{ item.price | currency }}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </transition>
        </template>
      </heim-table>
    </section>

    <section class="table flex" v-if="selectedProjectId">
      <heim-table :data="monthlyMonitoring" :columns="['username', 'total']" cols="2">
        <template slot="thead" slot-scope="props">
          <th class=""></th>
          <th class="main sortable" @click="props.sortBy('username')">{{ $t('conductedMonitoring') }}<heim-icon :icon="props.sortOrders['username'] == 'asc' ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable" @click="props.sortBy('total')">Total<heim-icon :icon="props.sortOrders['total'] == 'asc' ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr>
            <td>
              <heim-icon-button
                :class="show(item)?'opened':''"
                class="icon-button"
                @click.native="openDetail(item)">
                <heim-icon icon="chevron-right"></heim-icon>
              </heim-icon-button>
            </td>
            <td>{{ item.username }}</td>
            <td class="">{{ item.total | number }}</td>
          </tr>
          <transition name="slide-fade" :key="'detail-'+index">
            <tr v-if="show(item)" class="detail" :data-detail="item.id">
              <td class="detail-row" :colspan="cols">
                <div class="detail-container">
                  <div class="row-list">
                    <div v-for="(month, index) in item.months" class="item" :key="`m-${index}`">
                      <span class="label">{{ month.month }}</span>
                      <div>{{ month.time | number }}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </transition>
        </template>
      </heim-table>
      <heim-table :data="remainingTime" :columns="['name', 'remainingDays']" cols="2">
        <template slot="thead" slot-scope="props">
          <th class="sortable" @click="props.sortBy('name')">{{ $t('remainingMonitoring') }}<heim-icon :icon="props.sortOrders['name'] == 'asc' ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable" @click="props.sortBy('remainingDays')">{{ $t('days') }}<heim-icon :icon="props.sortOrders['remainingDays'] == 'asc' ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.remainingDays | number }}</td>
          </tr>
        </template>
      </heim-table>
    </section>

    <section class="table" v-if="selectedProjectId && employeePwd">
      <heim-table :data="monitoring" :columns="['meeting', 'price', 'projection', 'remaining', 'done', 'comments']" cols="6">
        <template slot="thead" slot-scope="props">
          <th class="main" @click="props.sortBy('meeting')">{{ $t('meeting') }}</th>
          <th @click="props.sortBy('price')">{{ $t('projection') }} {{ $t('cost') }}</th>
          <th @click="props.sortBy('projection')">{{ $t('projection') }}</th>
          <th @click="props.sortBy('remaining')">{{ $t('remaining') }}</th>
          <th @click="props.sortBy('done')">{{ $t('done') }}</th>
          <th @click="props.sortBy('comments')">{{ $t('comment') }}</th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr>
            <td>{{ item.date | date }}</td>
            <td>{{ item.price }}</td>
            <td>{{ item.projection }}</td>
            <td>{{ item.remaining }}</td>
            <td>{{ item.done }}</td>
            <td>{{ item.comments }}</td>
          </tr>
        </template>
      </heim-table>
    </section>

    <section class="margin-modal" v-if="selectedProjectId && employeePwd">
      <div class="margin-container">
        <heim-table :data="computedMargin" :columns="['remaining', 'days']" cols="2">
          <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
            <tr>
              <td>{{ $t(item.marginLabel) }}</td>
              <td class="data">{{ item.marginData | number }} %</td>
            </tr>
          </template>
        </heim-table>
      </div>
    </section>

    <modal name="login" class="modal" height="auto" @opened="opened">
      <form @submit.prevent="handleGetFinancials">
        <heim-input id="login" type="password" label="Mot de passe" name="password" v-model="password" v-validate="'required'"></heim-input>
        <footer class="flex-right">
          <heim-button type="button" class="cost-cancel cancel-button" @click.native="$modal.hide('login')">Retour</heim-button>
          <heim-button type="submit">Valider</heim-button>
        </footer>
      </form>
    </modal>

  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import { mapState } from "vuex";

export default {
  name: 'MonitoringsList',
  components: {
    HeimIcon,
    HeimInput,
    HeimIconButton,
    HeimButton,
    HeimTable,
    HeimSelect
  },
  async mounted() {
    await this.$store.dispatch("getProjectContract");

    if (this.projectId) {
      this.callDispatchs();
      this.selectedProjectId = this.projects.filter(e => e.id == this.projectId)[0].id || "";
    }
  },
  data() {
    return {
      selectedProjectId: "",
      password: "",
    }
  },
  computed: {
    //Project id
    ...mapState({ projectId: state => state.projectId }),

    ...mapState({ monitoring: state => state.monitoringsState.monitoring }),
    ...mapState({ projects: state => state.monitoringsState.contracts }),
    ...mapState({ projectPrice: state => state.monitoringsState.projectPrice }),
    ...mapState({ projectTime: state => state.monitoringsState.projectTime }),
    ...mapState({ remainingTime: state => state.monitoringsState.remainingTime }),
    ...mapState({ monthlyMonitoring: state => state.monitoringsState.projectMonth }),
    // Financial computed data
    ...mapState({ employeePwd: state => state.employeePwd }),
    ...mapState({ pastInfo: state => state.employeesState.pastInfo }),
    ...mapState({ futureInfo: state => state.employeesState.futureInfo }),
    // initialProjectTime() {
    //   if (this.projectTime.length) { return this.projectTime.map(e => e.chiffrageinitial).reduce((a,b) => a + b); }
    // },
    doneProjectTime() {
      if (this.projectTime.length) { return this.projectTime.map(e => e.chiffragepasse).reduce((a,b) => a + b); }
    },
    remainingProjectTime() {
      if (this.projectTime.length) { return this.projectTime.map(e => e.chiffragerestant).reduce((a,b) => a + b); }
    },
    computedProjectTime() {
      let projectTimeArray = [];
      if (this.projectTime.length) {
        projectTimeArray = [
          {
            label: 'clientPrice',
            days: this.projectPrice.length ? this.projectPrice[0].clientDays : 0,
            price: this.projectPrice.length ? this.projectPrice[0].clientPrice : 0
          },
          {
            label: 'objective',
            // days: this.initialProjectTime.toFixed(2),
            days: this.projectPrice.length ? this.projectPrice[0].objectiveDays : 0,
            price: this.projectPrice.length ? this.projectPrice[0].objectivePrice : 0
          },
          {
            label: 'done',
            days: this.doneProjectTime.toFixed(2),
            price: this.computedPastFinancial || 0
          },
          {
            label: 'remaining',
            days: this.remainingProjectTime.toFixed(2),
            price: this.computedFutureFinancial || 0
          },
          {
            label: 'projection',
            days: (this.doneProjectTime + this.remainingProjectTime).toFixed(2),
            price: (this.computedPastFinancial || 0) + (this.computedFutureFinancial || 0)
          }
        ];
      }
      return projectTimeArray;
    },
    computedMargin() {
      const marginArray = [];
      if (this.computedProjectTime.length) {
        marginArray.push({
          marginLabel: 'objectiveMargin',
          marginData: this.computedProjectTime[0].price ? 100 - ( this.computedProjectTime[1].price * 100 / this.computedProjectTime[0].price) : 0
        },
        {
          marginLabel: 'doneMargin',
          marginData: this.computedProjectTime[0].price ? 100 - ( this.computedProjectTime[4].price * 100 / this.computedProjectTime[0].price) : 0
        });
      }
      return marginArray;
    },
    // computedRemainingDays() {
    //   let remainingDays = [];
    //   if (this.remainingTime.length) {
    //     const usernameArray = this.remainingTime.map(e => e.realname).filter((v, i, a) => a.indexOf(v) === i);
    //     for (let i = 0; i < usernameArray.length; i++) {
    //       const filteredArray = this.remainingTime.filter(e => e.realname == usernameArray[i]);
    //       remainingDays.push({
    //         id: i,
    //         user_id : filteredArray[0].user_id,
    //         name: usernameArray[i],
    //         remainingDays: filteredArray.map(e => e.JourRestant).reduce((a,b) => a + b)
    //       });
    //     }
    //   }
    //   return remainingDays;
    // },
    // computedMonthlyMonitoring() {
    //   let projectMonitoring = [];
    //   if (this.monthlyMonitoring.length) {
    //     let total = 0;
    //     const projectMonths = this.monthlyMonitoring.map(e => e.mois).filter((v, i, a) => a.indexOf(v) === i);
    //     const usernames = this.monthlyMonitoring.map(e => e.realname).filter((v, i, a) => a.indexOf(v) === i);

    //     for (let i = 0; i < usernames.length; i++) {
    //       let dayTimeArray = [];
    //       const userMonitoring = this.monthlyMonitoring.filter(e => e.realname == usernames[i]);
    //       for (let j = 0; j < projectMonths.length; j++) {
    //         const dayTime = userMonitoring.filter(e => e.mois == projectMonths[j]).map(e => e.nbJour);
    //         let monthTime = dayTime.length ? Number(dayTime.reduce((a,b) => a + b)) : 0;
    //         dayTimeArray.push({
    //           month : projectMonths[j],
    //           time: monthTime
    //         });
    //         total = total + monthTime;
    //       }
    //       projectMonitoring.push({
    //         id: i,
    //         user_id: userMonitoring[0].user_id,
    //         username: usernames[i],
    //         months: dayTimeArray,
    //         total: total
    //       })
    //       total = 0;
    //     }
    //   }
    //   return projectMonitoring;
    // },
    computedPastFinancial() {
      let price = 0;

      if (this.monthlyMonitoring.length && this.pastInfo.length) {
        for (let i = 0; i < this.monthlyMonitoring.length; i++) {
          const employee = this.monthlyMonitoring[i];
          // Retrieves all prices in pastInfo for an employee
          const filteredId = this.pastInfo.find(e => e.id == employee.user_id);

          if (filteredId && filteredId.prices.length) {
            for (let j = 0; j < employee.months.length; j++) {
              /* Reverse the date because of inversion between month & day in original data */
              const reverseDate = employee.months[j].month.split('/').reverse().join('-');
              // Filters on filteredId in order to retrieve the closest price for the month checked
              const filteredMonth = filteredId.prices.filter(e => new Date(e.month) <= new Date(reverseDate));
              // If closest price exists, calculate the price
              if (filteredMonth.length) {
                price = price + (employee.months[j].time * filteredMonth[0].price);
              }
            }
          }
        }
      }
      return price;
    },
    computedFutureFinancial() {
      let price = 0;
      if (this.remainingTime.length && this.pastInfo.length) {
        for (let i = 0; i < this.remainingTime.length; i++) {
          const employee = this.remainingTime[i];
          // Retrieves all prices in futureInfo for an employee
          const filteredId = this.pastInfo.find(e => e.id == employee.user_id);
          // If future price exists for this employee, calculate price
          if (filteredId && filteredId.prices.length) {
            price = price + (filteredId.prices[0].price * employee.remainingDays);
          }
        }
      }
      return price;
    }
  },
  methods: {
    openModal() {
      this.$modal.show('login');
    },
    //Give focus to input here, because with before-open event, modal not added to the DOM yet
    opened() {
      this.$el.querySelector("#login input").focus();
    },
    async handleGetFinancials() {
      const data = await this.callPastInfo(this.password);
      if (data) {
        this.$store.dispatch("getEmployees");
        this.$store.dispatch("setEmployeePwd", this.password);
        this.$store.dispatch("getMonitoring", { id : this.projectId, password: this.employeePwd });
        // await this.callFutureInfo(this.password);
      } else {
        this.$store.dispatch("setToastMessage", {
          message: `Mot de passe invalide`
        });
        this.$store.dispatch("setToastMode", { mode: "error" });
        this.$store.dispatch("setOpenToast", { opened: true });
      }
      this.$modal.hide('login');
    },
    async callPastInfo(pwd) {
      let infoArray = [];
      if (this.monthlyMonitoring.length) {
        // Create an array of ids to send to request
        let idArray = this.monthlyMonitoring.map(e => e.user_id);
        infoArray = await this.$store.dispatch("getEmployeePastInfo", { id: idArray , password: pwd });
      }
      return infoArray;
    },
    async callFutureInfo(pwd) {
      let infoArray = [];
      if (this.remainingTime.length) {
        // Create an array of ids to send to request
        let idArray = this.remainingTime.map(e => e.user_id)
        infoArray = await this.$store.dispatch("getEmployeeFutureInfo", { id: idArray , password: pwd });
      }
      return infoArray;
    },
    async callDispatchs() {
      this.$store.dispatch("getProjectTime", { id: this.projectId });
      this.$store.dispatch("getProjectPrice", { id: this.projectId });
      await this.$store.dispatch("getProjectRemainingTime", { id: this.projectId });
      await this.$store.dispatch("getProjectMonthMonitoring", { id: this.projectId });
      if (this.employeePwd) {
        this.$store.dispatch("getMonitoring", { id : this.projectId, password: this.employeePwd });
        await this.callPastInfo(this.employeePwd);
        // await this.callFutureInfo(this.employeePwd);
      }
    },
    handleSelectProject() {
      this.$store.dispatch("setProject", this.selectedProjectId);
      this.callDispatchs();
    },
    async handleSave() {
      const data = await this.$store.dispatch("saveData", { password: this.employeePwd });
      console.log(data);
      if (data) {
        this.$store.dispatch("getMonitoring", { id : this.projectId, password: this.employeePwd });
        this.$store.dispatch("setToastMessage", {
          message: "Les données ont été enregistrées"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
      }
    }
  }
}
</script>

<style scoped>
/* Header */
.header .flex-container { width: 100%; }

/* select & margin table */
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-container table { width: auto; }
.flex-container table .data { text-align: right; }

section.table { margin-bottom: 1rem; }

/* For the 'suivi realise' table */
table .row-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.35em 1.5em;
}

td.detail-row .item, .flex {
  display: flex;
  justify-content: space-between;
}
/* Suivi realise & suive restant */
.flex table {
  width: 49%;
}

/* Margin modal */
.margin-modal {
  display: flex;
  justify-content: flex-end;
  position: sticky;
  bottom: 50px;
  font-weight: 600;
  float: right;
}

.margin-modal .margin-container  {
  border: 2px solid var(--heim-secondary-color);
  border-radius: 8px;
  z-index: 1;
}
</style>

<style>
  .heim-select select.paper-input {
    background: var(--heim-white-color);
  }
</style>
<style src="@/assets/styles/modal.css"></style>